var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53279 1.38636C10.1849 0.204545 11.8151 0.204546 12.4672 1.38636L21.2705 17.3409C21.9226 18.5227 21.1075 20 19.8033 20H2.19672C0.892529 20 0.0774117 18.5227 0.729506 17.3409L9.53279 1.38636Z",
    fill: "#F97800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7539 7.56238C9.71792 6.98668 10.1751 6.5 10.752 6.5H11.248C11.8249 6.5 12.2821 6.98668 12.2461 7.56238L11.9296 12.6267C11.8989 13.1176 11.4918 13.5 11 13.5C10.5082 13.5 10.1011 13.1176 10.0704 12.6267L9.7539 7.56238Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 15.6874,
    r: 1.3125,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastAlertIcon);
export default __webpack_public_path__ + "static/media/ToastAlertIcon.886a6fb9cbf75d161009e43e4fdee5ff.svg";
export { ForwardRef as ReactComponent };